var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m-menu__link timetrack" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-sm m-btn m-btn m-btn--icon m--margin-right-15",
        class: { "btn-default": _vm.activeTimetracks.length == 0 },
        on: {
          click: function($event) {
            _vm.timetrackingOpen = !_vm.timetrackingOpen
          }
        }
      },
      [
        _c("i", { staticClass: "m-menu__link-icon la la-hourglass-end" }),
        _vm._v(" "),
        _c("span", { staticClass: "m-menu__link-title" }, [
          _c("span", { staticClass: "m-menu__link-wrap" }, [
            _c("span", { staticClass: "m-menu__link-text" }, [
              _vm._v("Timetracking")
            ]),
            _vm._v(" "),
            _vm.activeTimetracks.length > 0
              ? _c("span", { staticClass: "m-menu__link-badge" }, [
                  _c("span", { staticClass: "m-badge m-badge--danger" }, [
                    _vm._v(_vm._s(_vm.activeTimetracks.length))
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.showFinishTimetrackItem
      ? _c("div", { staticClass: "timetracking-modal" }, [
          _c("div", { staticClass: "timetracking-modal__headline" }, [
            _vm._v("Timetrack speichern")
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "m-form m-form--fit m-form--label-align-right",
              attrs: { _lpchecked: "1" }
            },
            [
              _c("div", { staticClass: "m-portlet__body" }, [
                _c("div", { staticClass: "form-group m-form__group row" }, [
                  _c(
                    "label",
                    { staticClass: "col-form-label col-lg-3 col-sm-12" },
                    [_vm._v("Zeit (hh:mm)")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-9 col-md-9 col-sm-12" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.finishTimetrackItem.count,
                          expression: "finishTimetrackItem.count"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", name: "count" },
                      domProps: { value: _vm.finishTimetrackItem.count },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.finishTimetrackItem,
                            "count",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group m-form__group row" }, [
                  _c(
                    "label",
                    { staticClass: "col-form-label col-lg-3 col-sm-12" },
                    [_vm._v("Datum (tt.mm.yyyy)")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-9 col-md-9 col-sm-12" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.finishTimetrackItem.tracking_date,
                          expression: "finishTimetrackItem.tracking_date"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", name: "count" },
                      domProps: {
                        value: _vm.finishTimetrackItem.tracking_date
                      },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.finishTimetrackItem,
                            "tracking_date",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group m-form__group row" }, [
                  _c(
                    "label",
                    { staticClass: "col-form-label col-lg-3 col-sm-12" },
                    [_vm._v("Kategorie")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-9 col-md-9 col-sm-12" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.finishTimetrackItem.category_id,
                            expression: "finishTimetrackItem.category_id"
                          }
                        ],
                        staticClass: "form-control m-input m-input--square",
                        attrs: { id: "timetrackArr" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.finishTimetrackItem,
                              "category_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "0" } }, [
                          _vm._v("Bitte wählen")
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.timetrackCategoryArr, function(
                          category,
                          key
                        ) {
                          return _c("option", { domProps: { value: key } }, [
                            _vm._v(_vm._s(category))
                          ])
                        })
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group m-form__group row" }, [
                  _c(
                    "label",
                    { staticClass: "col-form-label col-lg-3 col-sm-12" },
                    [_vm._v("Notiz")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-9 col-md-9 col-sm-12" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.finishTimetrackItem.note,
                          expression: "finishTimetrackItem.note"
                        }
                      ],
                      staticClass: "form-control m-input",
                      domProps: { value: _vm.finishTimetrackItem.note },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.finishTimetrackItem,
                            "note",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "m-portlet__foot m-portlet__foot--fit" },
                [
                  _c(
                    "div",
                    { staticClass: "m-form__actions m-form__actions" },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-9 ml-lg-auto" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-brand",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.saveFinishTimetrack()
                                }
                              }
                            },
                            [_vm._v("Speichern")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-default",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.showFinishTimetrackItem = false
                                }
                              }
                            },
                            [_vm._v("schließen")]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ])
      : _vm.timetrackingOpen
      ? _c(
          "div",
          { staticClass: "timetracking-modal" },
          [
            _c("div", { staticClass: "timetracking-modal__headline" }, [
              _vm._v("Aktive TimeTracks")
            ]),
            _vm._v(" "),
            _vm._l(_vm.activeTimetracks, function(timetrack) {
              return _c("div", { staticClass: "timetracking-modal__item" }, [
                _c("div", { staticClass: "timetracking-modal__name" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-secondary m-btn m-btn m-btn--icon m--margin-right-10",
                      attrs: { href: "#" }
                    },
                    [
                      _c("span", [
                        _c("i", { staticClass: "la la-user" }),
                        _c("span", [
                          _vm._v(
                            _vm._s(timetrack.project.client_id) +
                              " - " +
                              _vm._s(timetrack.project.client_project_count)
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" " + _vm._s(timetrack.project.name))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "timetracking-modal__button" }, [
                  _c("div", {}, [
                    timetrack.start === null
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary btn-sm m-btn m-btn m-btn--icon m--margin-right-15",
                            on: {
                              click: function($event) {
                                return _vm.startTimetrack(timetrack.project.id)
                              }
                            }
                          },
                          [_c("i", { staticClass: "la la-play" })]
                        )
                      : _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-danger btn-sm m-btn m-btn m-btn--icon m--margin-right-15",
                            on: {
                              click: function($event) {
                                return _vm.stopTimetrack(timetrack.project.id)
                              }
                            }
                          },
                          [_c("i", { staticClass: "la la-times-circle-o" })]
                        ),
                    _vm._v(" "),
                    _c("span", { staticClass: "timetracking-modal__zeit" }, [
                      _vm._v(_vm._s(timetrack.timeFormate))
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-success btn-sm m-btn m-btn m-btn--icon m--margin-left-15",
                        on: {
                          click: function($event) {
                            return _vm.finishTimetrack(timetrack.id)
                          }
                        }
                      },
                      [_c("i", { staticClass: "la la-save" })]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "timetracking-modal__delete",
                    on: {
                      click: function($event) {
                        return _vm.deleteTimetrack(timetrack.id)
                      }
                    }
                  },
                  [_vm._m(0, true)]
                )
              ])
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-danger btn-sm m-btn m-btn m-btn--icon" },
      [_c("i", { staticClass: "la la-close" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }